module.exports = "pegasus/assets/blocks/image-4-theme4.png";